import React from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'
import Label from '@/ui/Input/Label'
import CheckBoxIcon from '@/icons/CheckBox'
import CheckBoxOutlineBlank from '@/icons/CheckBoxOutlineBlank'

export default class Checkbox extends React.PureComponent {
  static propTypes = {
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    labelText: PropTypes.string,
    style: PropTypes.object,
    name: PropTypes.string,
    type: PropTypes.string,
    defaultChecked: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    checked: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    disabled: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    tabIndex: PropTypes.string,
    readOnly: PropTypes.bool,
    autoFocus: PropTypes.bool,
    value: PropTypes.any,
    values: PropTypes.object,
    theme: PropTypes.object.isRequired,
  }
  static defaultProps = {
    prefixCls: 'checkbox',
    className: '',
    style: {},
    theme: {},
    type: 'checkbox',
    defaultChecked: false,
    onFocus() {},
    onBlur() {},
    onChange() {},
  }
  constructor(props) {
    super(props)

    const checked = 'checked' in props ? props.checked : props.defaultChecked

    this.state = {
      checked,
    }
  }

  componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked,
      })
    }
  }

  focus() {
    this.input.focus()
  }

  blur() {
    this.input.blur()
  }

  handleChange = e => {
    const { props } = this
    if (props.disabled) {
      return
    }
    if (!('checked' in props)) {
      this.setState({
        checked: e.target.checked,
      })
    }
    props.onChange({
      target: {
        ...props,
        checked: e.target.checked,
      },
      stopPropagation() {
        e.stopPropagation()
      },
      preventDefault() {
        e.preventDefault()
      },
    })
  }

  saveInput = node => {
    this.input = node
  }

  render() {
    const {
      prefixCls,
      className,
      labelText,
      style,
      name,
      type,
      disabled,
      readOnly,
      tabIndex,
      onClick,
      onFocus,
      onBlur,
      autoFocus,
      value,
      theme,
      ...others
    } = this.props

    const globalProps = Object.keys(others).reduce((prev, key) => {
      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
        prev[key] = others[key]
      }
      return prev
    }, {})

    const { checked } = this.state
    const classString = classNames(theme, className, {
      [`${prefixCls}-checked`]: checked,
      [`${prefixCls}-disabled`]: disabled,
    })

    return (
      <div className={classString} style={style}>
        <If condition={labelText}>
          <Label key="label" htmlFor={this.props.id}>
            {labelText}
          </Label>
        </If>
        <span className={theme[`${prefixCls}-inner`]}>
          <input
            name={name}
            type={type}
            readOnly={readOnly}
            disabled={disabled}
            tabIndex={tabIndex}
            className={`${prefixCls}-input`}
            checked={!!checked}
            onClick={onClick}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={this.handleChange}
            autoFocus={autoFocus}
            ref={this.saveInput}
            value={value}
            {...globalProps}
          />
          <Choose>
            <When condition={checked}>
              <label key="label2" htmlFor={this.props.id} className={'disablepointer'}>
                <CheckBoxIcon size="2em" />
              </label>
            </When>
            <When condition={!checked}>
              <label key="label3" htmlFor={this.props.id} className={'disablepointer'}>
                <CheckBoxOutlineBlank size="2em" />
              </label>
            </When>
          </Choose>
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/Input/CheckBox.js